import _extends from "@babel/runtime/helpers/extends";
import { useTheme } from "@smartsheet/lodestar-core";
import { AlertErrorFilledIcon, WarningFilledIcon, InfoFilledIcon, SuccessFilledIcon } from "@smartsheet/ursa-icons";
import React, { forwardRef, useMemo } from "react";
import { ToastIconContainer } from "../styled/ToastIconContainer";
import { ToastStyled } from "../styled/ToastStyled";
import { toastTheme } from "../styled/toastTheme";
import { ToastContextProvider } from "./ToastContext";
const presets = {
  error: /*#__PURE__*/React.createElement(AlertErrorFilledIcon, {
    size: 24,
    color: "currentColor"
  }),
  success: /*#__PURE__*/React.createElement(SuccessFilledIcon, {
    size: 24,
    color: "currentColor"
  }),
  warning: /*#__PURE__*/React.createElement(WarningFilledIcon, {
    size: 24,
    color: "currentColor"
  }),
  info: /*#__PURE__*/React.createElement(InfoFilledIcon, {
    size: 24,
    color: "currentColor"
  })
};
const getIcon = (type, icon) => {
  if (icon === null) {
    return null;
  } else {
    return icon || presets[type];
  }
};
export const Toast = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    type,
    icon,
    clientId,
    ...rest
  } = _ref;
  const {
    key
  } = useTheme();
  const themeMode = key;
  const resolvedIcon = getIcon(type, icon);
  const memoizedToastContextValue = useMemo(() => ({
    type
  }), [type]);
  return /*#__PURE__*/React.createElement(ToastContextProvider, {
    value: memoizedToastContextValue
  }, /*#__PURE__*/React.createElement(ToastStyled, _extends({
    themeMode: themeMode,
    type: type,
    "data-client-id": clientId,
    ref: ref
  }, rest), resolvedIcon && /*#__PURE__*/React.createElement(ToastIconContainer, {
    "aria-hidden": true,
    iconColor: toastTheme.iconColor[type](themeMode)
  }, resolvedIcon), children));
});
Toast.displayName = "Toast";
//# sourceMappingURL=Toast.js.map